module.exports = __webpack_public_path__ + "static/media/S (113).65d81b32.jpg";